import script from "./MainOnboardProfileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOnboardProfileComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainOnboardProfileComponent.vue?vue&type=style&index=0&id=16842951&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16842951"]])

export default __exports__